import * as React from "react";
import { SVGProps } from "react";

const GolemNetworkTokens = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1417 1417" {...props}>
    <path
      fill="#181ea9"
      d="M708.7 0C317.9 0 0 317.9 0 708.7s317.9 708.7 708.7 708.7 708.7-317.9 708.7-708.7S1099.4 0 708.7 0zm0 1377.2c-368.6 0-668.5-299.9-668.5-668.5S340 40.2 708.7 40.2s668.5 299.9 668.5 668.5-299.9 668.5-668.5 668.5zm135-967.5-62.2 62.2c-21.1-15.1-46.9-23.9-74.8-23.9-71.2 0-129.1 57.9-129.1 129.1 0 63.9 46.6 117 107.6 127.3v46.7c-61 10.3-107.6 63.4-107.6 127.3 0 71.2 57.9 129.1 129.1 129.1 71.2 0 129.1-57.9 129.1-129.1 0-63.9-46.6-117-107.6-127.3v-46.7c61-10.3 107.6-63.4 107.6-127.3 0-27.8-8.9-53.6-23.9-74.8l62.2-62.2-30.4-30.4zm-50.9 468.8c0 47.5-38.6 86.1-86.1 86.1s-86.1-38.6-86.1-86.1c0-47.5 38.6-86.1 86.1-86.1s86.1 38.6 86.1 86.1zm-86.1-215.3c-47.5 0-86.1-38.6-86.1-86.1 0-47.5 38.6-86.1 86.1-86.1s86.1 38.6 86.1 86.1c0 47.5-38.6 86.1-86.1 86.1z"
    />
  </svg>
);

export default GolemNetworkTokens;
